import { render, staticRenderFns } from "./expedicao.vue?vue&type=template&id=3540c9d2"
import script from "./expedicao.ts?vue&type=script&lang=js&external"
export * from "./expedicao.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/1/s/TafStore.PharmUP.Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3540c9d2')) {
      api.createRecord('3540c9d2', component.options)
    } else {
      api.reload('3540c9d2', component.options)
    }
    module.hot.accept("./expedicao.vue?vue&type=template&id=3540c9d2", function () {
      api.rerender('3540c9d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/home/fastaction/expedicao/expedicao.vue"
export default component.exports